import { getParams } from "./getParams";
import { apiResolver } from "./apiResolver";

export const resolvePromise = (onInfoChange) => {
  let params = getParams();
  let resolverPromise;
  if (params["path"])
    resolverPromise = new Promise(function (resolve, reject) {
      resolve(function (m) {
        return params["path"] + "/" + m;
      });
    });
  else resolverPromise = apiResolver(params["viewerId"], onInfoChange);

  return resolverPromise;
};
